<template>
  <esg-base-dashboard-card title="배출량 Top 5">
    <template #actions>
      <b-col>
        <b-row>
          <b-form-select v-model="typeOption"
                         size="sm">
            <option value='all'>ALL</option>
            <option v-for="option in typeOptions"
                    :key="option"
                    :value="option">{{ option }}
            </option>
          </b-form-select>
        </b-row>
      </b-col>
    </template>
    <esg-base-chart height="300px">
      <apex-chart ref="chart"
                  v-if="data"
                  type="bar"
                  height="250"
                  :options="chartOptions"
                  :series="series"/>
    </esg-base-chart>
  </esg-base-dashboard-card>
</template>
<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  name: 'CT00037',
  components: {EsgBaseChart, EsgBaseDashboardCard},
  props: ['data'],
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          type: 'bar',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          enabled: false,
          bar: {
            horizontal: true,
            barHeight: '50%',
            dataLabels: {
              position: 'top',
            },
          }
        },
        dataLabels: {
          enabled: true,
          offsetX: -3,
          formatter: function (val) {
            return Math.round(val, 3).toLocaleString('ko-KR')
          },
          style: {
            fontSize: '12px',
            colors: ['#000000']
          }
        },
        xaxis: {
          categories: [],
          labels: {
            show: false
          }
        },
        grid: {
          show: false
        },
        tooltip: {
          enabled: false,
          y: {
            show: false,
            formatter: function (val) {
              return Math.round(val, 3).toLocaleString('ko-KR') + " 원/tCO2e"
            },
          },
        },
      },
      rawData: [
        {
          corpName: 'EY 기계',
          type: '원료 획득',
          emissionAmt: 34938
        },
        {
          corpName: 'EY 에너지',
          type: '원료 획득',
          emissionAmt: 8311
        },
        {
          corpName: 'EY 운송',
          type: '업스트림 운송',
          emissionAmt: 34845
        },
        {
          corpName: 'EY 택배',
          type: '다운스트림 운송',
          emissionAmt: 13938
        },
        {
          corpName: 'EY 국제운송',
          type: '다운스트림 운송',
          emissionAmt: 20916
        },
        {
          corpName: 'EY DK',
          type: '업스트림 운송',
          emissionAmt: 7922
        },
        {
          corpName: 'DT 운송',
          type: '업스트림 운송',
          emissionAmt: 8853
        },
        {
          corpName: 'PW 운송',
          type: '업스트림 운송',
          emissionAmt: 29784
        },
        {
          corpName: 'WC 정공',
          type: '원료 공급',
          emissionAmt: 27331
        },
        {
          corpName: 'FD 운송',
          type: '다운스트림 운송',
          emissionAmt: 15010
        },
      ],
      typeOption: 'all'
    }
  },
  created() {
    this.setSeries();
    this.setLabels();
  },
  computed: {
    typeOptions() {
      return new Set(this.rawData.map(obj => obj.type))
    }
  },
  watch: {
    data: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.setSeries();
          this.setLabels();
        }
      }
    },
    typeOption: {
      handler() {
        this.setSeries();
        this.setLabels();
        this.refreshChart();
      }
    }
  },
  methods: {
    async setSeries() {
      // 시각화 데이터 추출
      let targetData = this.rawData;
      if (this.typeOption !== 'all') {
        targetData = this.rawData.filter(obj => obj.type === this.typeOption);
      }

      targetData = targetData.sort((a, b) => {
        if (b.emissionAmt > a.emissionAmt) {
          return 1;
        } else if (b.emissionAmt < a.emissionAmt) {
          return -1;
        } else {
          return 0;
        }
      }).slice(0, 5);
      this.series = [{
        name: '배출비율',
        data: targetData.map(obj => obj.emissionAmt)
      }]
    },
    async setLabels() {
      // 시각화 레이블 추출
      let targetData = this.rawData;
      if (this.typeOption !== 'all') {
        targetData = this.rawData.filter(obj => obj.type === this.typeOption);
      }
      targetData = targetData.slice(0, 5);
      this.chartOptions.xaxis.categories = targetData.map(obj => obj.corpName);
    },

    async setData() {


    },
  }
}
</script>
